export const environment = {
  production: false,
  vestraApiUrl: '//api-vestra-staging.exe-cute.ch/'
};
